import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { IMessageTypeBubble } from "../MessagePanel";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import theme from "../../theme";
import { useTranslation } from "hhn-commons";

export const PriorityText = styled(Typography)`
  background: ${theme.palette.error.main};
  border-radius: inherit;
  margin: 3px;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  line-height: 0.8;
  font-weight: 500;

  svg {
    margin-right: 10px;
  }
`;

const PriorityBubble = (props: IMessageTypeBubble) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  return (
    <>
      <PriorityText>
        <WarningRoundedIcon color="inherit" fontSize="small" />
        {tNs("message.priorityMessage")}
      </PriorityText>
      {props.children}
    </>
  );
};

export default PriorityBubble;
